import React from 'react';
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES, GRID_CELL_SIZE_M } from '../configuratorConstants';
import { ReactComponent as WindowBlindsIcon } from '../../Assets/roleta.svg';

const WindowBlindsRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  associatedWindow,
  placementSideFactor,
  isFrameless = false, // Параметр для определения режима (модульный/безкаркасный)
}) => {
  // Если ролет не связан с окном, мы не можем его корректно отобразить.
  if (!associatedWindow) {
    return null;
  }

  const isPanoramic = associatedWindow.type === OBJECT_TYPES.PANORAMIC_WINDOW;
  
  // Определяем размеры и позиционирование в зависимости от режима и типа окна
  let blindsHeightPx;
  let blindsWidthPx;
  let yOffset;
  
  if (isFrameless) {
    // Безкаркасный режим
    if (isPanoramic) {
      // Безкаркасный режим + панорамное окно
      // Панорамное окно в безкаркасном занимает 2 сегмента (2 * GRID_CELL_SIZE_M)
      const windowWidthM = GRID_CELL_SIZE_M * 2;
      blindsHeightPx = (windowWidthM * 0.45) * scale; // 60% от ширины окна
      blindsWidthPx = 0.12 * scale; // 12см ширина
    } else {
      // Безкаркасный режим + обычное окно
      const windowWidthM = associatedWindow.width || defaultObjectSizes[associatedWindow.type]?.width || 1.2;
      blindsHeightPx = (windowWidthM * 0.85) * scale; // 85% от ширины окна
      blindsWidthPx = 0.1 * scale; // 10см ширина
    }
  } else {
    // Модульный режим
    if (isPanoramic) {
      // Модульный режим + панорамное окно
      // Панорамное окно в модульном занимает 2 сегмента (2 * GRID_CELL_SIZE_M)
      const windowWidthM = GRID_CELL_SIZE_M * 2;
      blindsHeightPx = (windowWidthM * 0.55) * scale; // 55% от ширины окна
      blindsWidthPx = 0.1 * scale; // 10см ширина
    } else {
      // Модульный режим + обычное окно
      const windowWidthM = associatedWindow.width || defaultObjectSizes[associatedWindow.type]?.width || 1.2;
      blindsHeightPx = (windowWidthM * 0.9) * scale; // 90% от ширины окна
      blindsWidthPx = 0.1 * scale; // 10см ширина
    }
  }
  
  // Высота ролета на 2D-плане соответствует толщине стены.
  const wallThicknessPx = wallThickness * scale;
  
  // Смещение по вертикали, чтобы ролет был с внешней стороны окна
  // Окно находится по центру стены, поэтому размещаем ролет снаружи
  yOffset = -placementSideFactor * (wallThicknessPx / 2 + blindsWidthPx / 2);

  const svgStyle = {
    fill: isSelected ? 'rgba(0, 123, 255, 0.2)' : '#e8e8e8',
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : '#666666',
    strokeWidth: isSelected ? 1.5 : 1,
  };

  // Поворачиваем SVG на 90 градусов, чтобы сделать его вертикальным
  const transform = `translate(0, ${yOffset}) rotate(0)`;
  
  return (
    <g transform={transform}>
      <WindowBlindsIcon
        x={-blindsHeightPx / 2}
        y={-blindsWidthPx / 2}
        width={blindsHeightPx}
        height={blindsWidthPx}
        style={svgStyle}
        preserveAspectRatio="none"
      />
    </g>
  );
};

export default React.memo(WindowBlindsRenderer);